module.exports = __webpack_public_path__ + "static/victoria-9d1059e58e7f85eb7e9f7c07a1038491.webp";